// 导入组件
import Vue from 'vue';
import Router from 'vue-router';

import index from '@/views/index'

// 启用路由
Vue.use(Router);

const originalPush = Router.prototype.push
Router.prototype.push = function push(location) {
    return originalPush.call(this, location).catch(err => err)
}

// 导出路由
export default new Router({
    // mode: 'history',  //去掉url中的#
    scrollBehavior(to, from, savePosition) {
        if (savePosition) {
            return savePosition
        } else {
            return { x: 0, y: 0 }
        }
    },
    routes: [{
            path: '/',
            name: '首页',
            // component: index,
            component: resolve => require(['@/views/index'], resolve),
            iconCls: 'el-icon-tickets',
            redirect: '/',
            hidden: true,
            meta: {
                requireAuth: false
            },
            children: [{
                    path: '/',
                    name: '嵌套在首页',
                    // component: main,
                    component: resolve => require(['@/views/dashboard/main'], resolve),
                    meta: {
                        requireAuth: false
                    }
                }, {
                    path: '/store',
                    name: '店铺街',
                    // component: store,
                    component: resolve => require(['@/views/store/store'], resolve),
                    meta: {
                        requireAuth: false
                    }
                },

                {
                    path: '/projectcasebg',
                    name: '电站运维',
                    // component: Operation,
                    component: resolve => require(['@/views/projectcasebg/index'], resolve),
                    meta: {
                        requireAuth: false
                    }
                },
                {
                    path: '/operations',
                    name: '电站项目',
                    // component: Operation,
                    component: resolve => require(['@/views/operations/index'], resolve),
                    meta: {
                        requireAuth: false
                    }
                },
                {
                    path: '/business',
                    name: '业务场景',
                    // component: business,
                    component: resolve => require(['@/views/Business/business'], resolve),
                    hidden: true,
                    meta: {
                        requireAuth: false
                    }
                },
                {
                    path: '/shophomepage',
                    name: '店铺首页',
                    // component: shophomepage,
                    component: resolve => require(['@/views/shophomepage/shophomepage'], resolve),
                    hidden: true,
                    meta: {
                        requireAuth: false
                    }
                },
                {
                    path: '/yellowpage',
                    name: '企业黄页',
                    // component: shophomepage,
                    component: resolve => require(['@/views/shophomepage/yellowpage'], resolve),
                    hidden: true,
                    meta: {
                        requireAuth: false
                    }
                },
                {
                    path: '/shopStore',
                    name: '店铺详情',
                    // component: shopStore,
                    component: resolve => require(['@/views/store/storeHome'], resolve),
                    meta: {
                        requireAuth: false
                    }
                },
                {
                    path: '/shoppingcart',
                    name: '购物车',
                    //component: shoppingcart,
                    component: resolve => require(['@/views/shoppingcart/shoppingcart'], resolve),
                    hidden: true,
                    meta: {
                        requireAuth: true
                    }
                },{
                    path: '/inquiryBasket',
                    name: '询价篮',
                    //component: shoppingcart,
                    component: resolve => require(['@/views/shoppingcart/inquiryBasket'], resolve),
                    hidden: true,
                    meta: {
                        requireAuth: true
                    }
                }, {
                path: '/batchOrder',
                name: '批量下单',
                //component: shoppingcart,
                component: resolve => require(['@/views/batchOrder/index'], resolve),
                hidden: true,
                meta: {
                  requireAuth: true
                }
              },{
                    path: '/orderDetail',
                    name: '购物车订单',
                    //component: orderDetail,
                    component: resolve => require(['@/views/shoppingcart/orderDetail'], resolve),
                    hidden: true,
                    meta: {
                        requireAuth: true
                    }
                }, {
                    path: '/orderNow',
                    name: '购物车付款',
                    //component: orderNow,
                    component: resolve => require(['@/views/shoppingcart/orderNow'], resolve),
                    hidden: true,
                    meta: {
                        requireAuth: true
                    }
                },
                {
                    path: '/paySuccess',
                    name: '支付成功',
                    // component: paySuccess,
                    component: resolve => require(['@/views/paySuccess'], resolve),
                    hidden: true,
                    meta: {
                        requireAuth: true
                    }
                },

                {
                    path: '/Guidance',
                    name: '引导升级企业',
                    //component: Guidance,
                    component: resolve => require(['@/views/Guidance'], resolve),
                    hidden: true,
                    meta: {
                        requireAuth: true
                    }
                },
                {
                    path: '/redenvelope',
                    name: '红包',
                    //component: redenvelopes,
                    component: resolve => require(['@/views/redenvelopes/index'], resolve),
                    hidden: true,
                    meta: {
                        requireAuth: false
                    }
                }, {
                    path: '/brand',
                    name: '品牌',
                    //component: brand,
                    component: resolve => require(['@/views/brand/index'], resolve),
                    hidden: true,
                    meta: {
                        requireAuth: false
                    }
                }, {
                    path: '/goodsList',
                    name: '商品列表',
                    // component: goodsList,
                    component: resolve => require(['@/views/goodsList/index'], resolve),
                    hidden: true,
                    meta: {
                        requireAuth: false
                    }
                }, {
                    path: '/goodsDetail',
                    name: '商品详情',
                    // component: goodsDetail,
                    component: resolve => require(['@/views/goodsList/goodsDetail'], resolve),
                    hidden: true,
                    meta: {
                        requireAuth: false
                    }
                },
                {
                    path: '/searchImgQuery',
                    name: '拍照识图列表',
                    component: resolve => require(['@/views/searchImgQuery/index'], resolve),
                    meta: {
                        requireAuth: true
                    },

                },
                {
                    path: '/pointMall',
                    name: '积分商城',
                    // component: pointMall,
                    component: resolve => require(['@/views/pointMall/pointMall'], resolve),

                    hidden: true,
                    meta: {
                        requireAuth: false
                    }
                },
                // pointsProDetails
                {
                    path: '/pointsProDetails',
                    name: '积分兑换',
                    // component: pointsProDetails,
                    component: resolve => require(['@/views/pointMall/pointsProDetails'], resolve),
                    hidden: true,
                    meta: {
                        requireAuth: false
                    }
                },
                {
                    path: '/limitDiscounts',
                    name: '限时折扣',
                    //component: limitDiscounts,
                    component: resolve => require(['@/views/limitDiscounts/index'], resolve),
                    hidden: true,
                    meta: {
                        requireAuth: false
                    }
                },
                {
                    path: '/spike',
                    name: '秒杀',
                    //component: spike,
                    component: resolve => require(['@/views/spike/index'], resolve),
                    hidden: true,
                    meta: {
                        requireAuth: false
                    }
                },
                {
                    path: '/tender',
                    name: '招标公告',
                    // component: tender,
                    component: resolve => require(['@/views/tender/index'], resolve),
                    hidden: true,
                    meta: {
                        requireAuth: true
                    }
                },
                {
                    path: '/tenderedit',
                    name: '公告编辑',
                    // component: tender,
                    component: resolve => require(['@/views/tender/tenderedit'], resolve),
                    hidden: true,
                    meta: {
                        requireAuth: true
                    }
                },
                {
                    path: '/mytender',
                    name: '我的公告',
                    // component: tender,
                    component: resolve => require(['@/views/tender/mytender'], resolve),
                    hidden: true,
                    meta: {
                        requireAuth: true
                    }
                },
                {
                    path: '/tenderdetails',
                    name: '招标详情',
                    // component: tenderdetails,
                    component: resolve => require(['@/views/tender/tenderdetails'], resolve),
                    hidden: true,
                    meta: {
                        requireAuth: true
                    }
                },
                {
                    path: '/cooperation',
                    name: '招标合作',
                    //component: cooperation,
                    component: resolve => require(['@/views/cooperation/index'], resolve),
                    hidden: true,
                    meta: {
                        requireAuth: false
                    }
                },
                {
                    path: '/aboutZt',
                    name: '关于云赢',
                    // component: aboutZt,
                    component: resolve => require(['@/views/aboutZt/index'], resolve),
                    hidden: true,
                    meta: {
                        requireAuth: false
                    }
                },
                {
                    path: '/electricianImg',
                    name: '电工入驻广告',
                    //component: electricianImg,
                    component: resolve => require(['@/views/electricianImg/index'], resolve),
                    hidden: true,
                    meta: {
                        requireAuth: false
                    }
                },
                {
                    path: '/publicity',
                    name: '宣传页',
                    //component: publicity,@/views/publicity/index
                    component: resolve => require(['@/views/publicity/index'], resolve),
                    hidden: true,
                    meta: {
                        requireAuth: false
                    }
                },
                {
                    path: '/contact',
                    name: '联系云赢',
                    //component: contact,
                    component: resolve => require(['@/views/contact/index'], resolve),
                    hidden: true,
                    meta: {
                        requireAuth: false
                    }
                },
                {
                    path: '/forum',
                    name: '论坛首页',
                    redirect: '/forum/forumIndex',
                    //component: forum,
                    component: resolve => require(['@/views/forum/index'], resolve),
                    hidden: true,
                    meta: {
                        requireAuth: false
                    },
                    children: [
                        {
                        path: '/forum/forumIndex', //以“//”;
                        name: '论坛',
                        //component: forumIndex,
                        component: resolve => require(['@/views/forum/forumIndex'], resolve),
                        meta: {
                            requireAuth: true
                        },

                    },
                    {
                        path: '/forum/forumList',
                        name: '论坛列表',
                        component: resolve => require(['@/views/forum/forumList'], resolve),
                        meta: {
                            requireAuth: true
                        },

                    },{
                        path: '/forum/forumConter',
                        name: '帖子主题',
                        component: resolve => require(['@/views/forum/forumConter'], resolve),
                        meta: {
                            requireAuth: true
                        },

                    },{
                        path: '/forum/posting',
                        name: '发帖',
                        component: resolve => require(['@/views/forum/posting'], resolve),
                        meta: {
                            requireAuth: true,
                            tittle:'发布帖子'
                        },

                    },{
                        path: '/forum/myposting',
                        name: '我的帖子',
                        component: resolve => require(['@/views/forum/myposting'], resolve),
                        meta: {
                            requireAuth: true
                        },

                    }

                ]
                },
                {
                    path: '/welcomesystem',
                    name: '欢迎商家入驻',
                    // component: welcomesystem,
                    component: resolve => require(['@/views/merchantSettled/welcomesystem'], resolve),
                    hidden: true,
                    meta: {
                        requireAuth: true
                    }
                },{
                    path: '/centralizedPurchasing',
                    name: '商家入驻欢迎',
                    // component: welcomesystem,
                    component: resolve => require(['@/views/goodsList/centralizedPurchasing'], resolve),
                    hidden: true,
                    meta: {
                        requireAuth: true
                    }
                },
                {
                    path: '/welcomeelectrician',
                    name: '电工入驻欢迎',
                    // component: welcomeelectrician,
                    component: resolve => require(['@/views/merchantSettled/welcomeelectrician'], resolve),
                    hidden: true,
                    meta: {
                        requireAuth: true
                    }
                },
                , {
                    path: '/merchantTypeSelect',
                    name: '商家入驻选择',
                    //component: merchantTypeSelect,
                    component: resolve => require(['@/views/merchantSettled/merchantTypeSelect'], resolve),
                    hidden: true,
                    meta: {
                        requireAuth: true
                    }
                },
                {
                    path: '/merchantApply',
                    name: '商家入驻协议',
                    //component: merchantApply,
                    component: resolve => require(['@/views/merchantSettled/merchantApply'], resolve),
                    hidden: true,
                    meta: {
                        requireAuth: true
                    }
                }, {
                    path: '/merchantForm',
                    name: '商家入驻表单',
                    //component: merchantForm,
                    component: resolve => require(['@/views/merchantSettled/merchantForm'], resolve),
                    hidden: true,
                    meta: {
                        requireAuth: true
                    }
                }, {
                    path: '/merchantFormTwo',
                    name: '商家入驻补录表单',
                    //component: merchantFormTwo,
                    component: resolve => require(['@/views/merchantSettled/merchantFormTwo'], resolve),
                    hidden: true,
                    meta: {
                        requireAuth: true
                    }
                }, {
                    path: '/merchantStatus',
                    name: '商家入驻平台审核',
                    //component: merchantStatus,
                    component: resolve => require(['@/views/merchantSettled/merchantStatus'], resolve),
                    hidden: true,
                    meta: {
                        requireAuth: true
                    }
                }, {
                    path: '/merchantpayFor',
                    name: '商家入驻平台交费',
                    //component: merchantpayFor,
                    component: resolve => require(['@/views/merchantSettled/menchantpayFor'], resolve),
                    hidden: true,
                    meta: {
                        requireAuth: true
                    }
                }, {
                    path: '/storeOpen',
                    name: '商家入驻店铺开通',
                    //component: storeOpen,
                    component: resolve => require(['@/views/merchantSettled/storeOpen'], resolve),
                    hidden: true,
                    meta: {
                        requireAuth: true
                    }
                },
                {
                    path: '/gotoEvaluation',
                    name: '去评价',
                    // component: gotoEvaluation
                    component: resolve => require(['@/views/myOrder/evaluationePage/gotoEvaluation'], resolve),
                },
                {
                    path: '/orderAppraisal',
                    name: '订单评价',
                    // component: orderAppraisal //orderAppraisal
                    component: resolve => require(['@/views/myOrder/evaluationePage/orderAppraisal'], resolve),
                },
                {
                    path: '/evaluationDetail',
                    name: '商品评价详情',
                    // component: evaluationDetail
                    component: resolve => require(['@/views/myOrder/evaluationePage/evaluationDetail'], resolve),
                },
                {
                    path: '/serviceArticle',
                    name: '文章分类',
                    redirect: '/siteHelp',
                    //component: serviceArticle,
                    component: resolve => require(['@/views/serviceArticle/index'], resolve),
                    hidden: true,
                    meta: {
                        requireAuth: true
                    },
                    children: [{
                            path: '/siteHelp',
                            name: '站点帮助',
                            //component: siteHelp,
                            component: resolve => require(['@/views/serviceArticle/siteHelp'], resolve),
                            meta: {
                                requireAuth: true
                            },

                        },
                        {
                            path: '/siteHelpDetail',
                            name: '站点帮助详情',
                            //component: siteHelpDetail,
                            component: resolve => require(['@/views/serviceArticle/siteHelpDetail'], resolve),
                            meta: {
                                requireAuth: true
                            },

                        },
                    ]
                },
                {
                    path: '/myOrder',
                    name: '我的订单',
                    redirect: '/myOrderRight',
                    //component: myOrder,
                    component: resolve => require(['@/views/myOrder/index'], resolve),
                    hidden: true,
                    meta: {
                        requireAuth: true
                    },
                    children: [{
                            path: '/myOrderRight',
                            name: '在线支付',
                            //component: myOrderRight,
                            component: resolve => require(['@/views/myOrder/myOrder'], resolve),
                            meta: {
                                requireAuth: true
                            },

                        },
                        // cashOnDelivery
                        {
                            path: '/cashOnDelivery',
                            name: '货到付款',
                            //component: cashOnDelivery,
                            component: resolve => require(['@/views/myOrder/cashOnDelivery'], resolve),
                            meta: {
                                requireAuth: true
                            },

                        },
                        {
                            path: '/cashInquirySheet',
                            name: '询价单',
                            //component: cashOnDelivery,
                            component: resolve => require(['@/views/myOrder/cashInquirySheet'], resolve),
                            meta: {
                                requireAuth: true
                            },

                        },
                        {
                            path: '/myOrderDetail',
                            name: '订单详情',
                            // component: myOrderDetail
                            component: resolve => require(['@/views/myOrder/myOrderDetail'], resolve),
                        },
                        {
                            path: '/logistics',
                            name: '查看物流',
                            component: resolve => require(['@/views/myOrder/logistics'], resolve),
                        },
                        {
                            path: '/myRefund', //退款页面 付完钱可以申请退款页面
                            name: '退款编写',
                            // component: myRefund
                            component: resolve => require(['@/views/myOrder/myRefund'], resolve),
                        },
                        {
                            path: '/refundDetail', //退款页面 付完钱可以申请退款页面
                            name: '退款详情',
                            // component: refundDetail
                            component: resolve => require(['@/views/myOrder/refundDetail'], resolve),
                        },
                        {
                            path: '/goodsAppraisal',
                            name: '评价管理',
                            component: resolve => require(['@/views/myOrder/goodsAppraisal'], resolve),
                        },
                        {
                            path: '/pointsOrder',
                            name: '积分订单',
                            // component: pointsOrder
                            component: resolve => require(['@/views/myOrder/pointsOrder'], resolve),
                        },
                        {
                            path: '/goodsCollection',
                            name: '商品收藏',
                            // component: goodsCollection,
                            component: resolve => require(['@/views/myOrder/attentionCenter/goodsCollection'], resolve),
                            meta: {
                                requireAuth: true
                            },
                        },
                        {
                            path: '/shopCollection',
                            name: '店铺收藏',
                            // component: shopCollection,
                            component: resolve => require(['@/views/myOrder/attentionCenter/shopCollection'], resolve),
                        },
                        {
                            path: '/myFooter',
                            name: '我的足迹',
                            // component: myFooter,
                            component: resolve => require(['@/views/myOrder/attentionCenter/myFooter'], resolve),
                            meta: {
                                requireAuth: true
                            },
                        },
                        {
                            path: '/myInfomation',
                            name: '个人信息',
                            // component: myInfomation,
                            component: resolve => require(['@/views/myOrder/myCenter/myInfo'], resolve),
                            meta: {
                                requireAuth: true
                            },
                        },
                        {
                            path: '/address',
                            name: '收获地址',
                            // component: address
                            component: resolve => require(['@/views/myOrder/myCenter/address'], resolve),
                        },
                        {
                            path: '/userinvoice',
                            name: '发票管理',
                            // component: userinvoice,
                            component: resolve => require(['@/views/myOrder/cashOnDelivery'], resolve),
                        },
                        {
                            path: '/userTitleInvoice',
                            name: '抬头管理',
                            // component: userTitleInvoice,
                            component: resolve => require(['@/views/myOrder/myCenter/userTitleInvoice'], resolve),
                        },
                        {
                            path: '/businessContact',
                            name: '业务联系',
                            // component: businessContact
                            component: resolve => require(['@/views/myOrder/myCenter/businessContact'], resolve),
                        },
                        {
                            path: '/feedback',
                            name: '意见反馈',
                            // component: feedback
                            component: resolve => require(['@/views/myOrder/myCenter/feedback'], resolve),
                        },
                        {
                            path: '/refund',
                            name: '退款退货',
                            // component: refund
                            component: resolve => require(['@/views/myOrder/customerService/refund'], resolve),
                        },
                        {
                            path: '/consultation',
                            name: '商品咨询',
                            // component: consultation
                            component: resolve => require(['@/views/myOrder/customerService/consultation'], resolve),
                        },
                        {
                            path: '/myScores',
                            name: '我的积分',
                            // component: myScores
                            component: resolve => require(['@/views/myOrder/propertyCenter/myScores'], resolve),
                        },
                        {
                            path: '/myRedPack',
                            name: '我的红包',
                            // component: myRedPack
                            component: resolve => require(['@/views/myOrder/propertyCenter/myRedPack'], resolve),
                        },
                        {
                            path: '/myBounty',
                            name: '我的赏金',
                            component: resolve => require(['@/views/bountyTask/myBounty'], resolve)
                        },
                        {
                          path: '/exchangeRecord',
                          name: '兑换记录',
                          component: resolve => require(['@/views/bountyTask/exchangeRecord'], resolve)
                        }
                    ]
                },
                 {
                    path: '/commonproblem',
                    name: '帮助中心',
                    redirect: '/commonproblem',
                    // component: commonproblem,@/views/commonproblem/index
                    component: resolve => require(['@/views/commonproblem/index'], resolve),
                    hidden: true,
                    meta: {
                        requireAuth: true
                    },
                    children: [{
                            path: '/commonproblem',
                            name: '常见问题',
                            // component: commonehelp,
                            component: resolve => require(['@/views/commonproblem/commonehelp'], resolve),
                            meta: {
                                requireAuth: true
                            },

                        },
                        {
                            path: '/invoice',
                            name: '发票流程',
                            // component: invoice,
                            component: resolve => require(['@/views/commonproblem/invoice'], resolve),
                            meta: {
                                requireAuth: true
                            },

                        },
                        {
                            path: '/orderdescription',
                            name: '下单说明',
                            // component: orderdescription,
                            component: resolve => require(['@/views/commonproblem/orderdescription'], resolve),
                            meta: {
                                requireAuth: true
                            },

                        },
                        {
                            path: '/delivery',
                            name: '配送说明',
                            // component: delivery,
                            component: resolve => require(['@/views/commonproblem/delivery'], resolve),
                            meta: {
                                requireAuth: true
                            },

                        },
                        {
                            path: '/payment',
                            name: '支付说明',
                            // component: payment,
                            component: resolve => require(['@/views/commonproblem/payment'], resolve),
                            meta: {
                                requireAuth: true
                            },

                        },
                        {
                            path: '/exchange',
                            name: '退换货流程',
                            // component: exchange,
                            component: resolve => require(['@/views/commonproblem/exchange'], resolve),
                            meta: {
                                requireAuth: true
                            },

                        },
                        {
                            path: '/aftersale',
                            name: '联系售后',
                            // component: aftersale,
                            component: resolve => require(['@/views/commonproblem/aftersale'], resolve),
                            meta: {
                                requireAuth: true
                            },

                        },
                        {
                            path: '/briefintroduction',
                            name: '云赢介绍',
                            // component: briefintroduction,
                            component: resolve => require(['@/views/commonproblem/briefintroduction'], resolve),
                            hidden: true,
                            meta: {
                                requireAuth: false
                            }
                        },
                        {
                            path: '/contactus',
                            name: '联系我们',
                            // component: contactus,
                            component: resolve => require(['@/views/commonproblem/contactus'], resolve),
                            hidden: true,
                            meta: {
                                requireAuth: false
                            }
                        },
                    ]
                },
              // 赏金任务
              {
                path: '/bountyTask',
                name: '赏金任务',
                component: resolve => require(['@/views/bountyTask/index'], resolve),
                hidden: true,
                meta: {
                  requireAuth: false
                },
                children: [
                  {
                    path: '',
                    name: '赏金任务',
                    component: resolve => require(['@/views/bountyTask/task'], resolve),
                    meta: {
                      requireAuth: false
                    },
                  },
                  {
                    path: '/mainImgTask',
                    name: '主图任务',
                    component: resolve => require(['@/views/bountyTask/mainImgTask'], resolve),
                    meta: {
                      requireAuth: true
                    }
                  },
                  {
                    path: '/specificationTask',
                    name: '规格任务',
                    component: resolve => require(['@/views/bountyTask/specificationTask'], resolve),
                    meta: {
                      requireAuth: true
                    }
                  }
                ]
              },
              {
                path: '/clean',
                name: '电站清洗',
                component: resolve => require(['@/views/clean/index'], resolve),
                hidden: true,
                meta: {
                  requireAuth: false
                },
                children: [
                    {
                        path: '',
                        name: '电站清洗',
                        component: resolve => require(['@/views/clean/list'], resolve),
                        meta: {
                            requireAuth: false
                        }
                    },
                    {
                        path: '/clean/detail',
                        name: '电站详情',
                        component: resolve => require(['@/views/clean/detail'], resolve),
                        meta: {
                            requireAuth: false
                        }
                    },
                    {
                        path: '/clean/map',
                        name: '电站地图',
                        component: resolve => require(['@/views/clean/map'], resolve),
                        meta: {
                            requireAuth: false
                        },
                    },
                    {
                        path: '/clean/editInfo',
                        name: '基础信息',
                        component: resolve => require(['@/views/clean/editInfo'], resolve),
                        meta: {
                            requireAuth: false
                        },
                    }
                ]
              }
            ]
        },
        {
            path: '/testPage',
            name: '测试页面',
            //component: testPage,
            component: resolve => require(['@/views/testPage'], resolve),
            hidden: true,
            meta: {
                requireAuth: false
            }
        },
        {
            path: '/earthMap',
            name: '电站全景地图',
            //component: testPage,
            component: resolve => require(['@/views/earthMap'], resolve),
            hidden: true,
            meta: {
                requireAuth: false
            }
        },
        {
            path: '/reportForms',
            name: '报表首页',
            //component: testPage,
            component: resolve => require(['@/views/reportForms/index'], resolve),
            hidden: true,
            meta: {
                requireAuth: false
            }
        },
        {
            path: '/user/historyagreement',
            name: '历史版本',
            component: resolve => require(['@/views/user/historyagreement'], resolve),
            meta: {
                requireAuth: false,
                keepAlive: true
            }
        },
        {
            path: '/login',
            name: '登录',
            //component: login,
            component: resolve => require(['@/views/login'], resolve),
            hidden: true,
            meta: {
                requireAuth: false
            }
        },
        {
            path: '/messageBox',
            name: '消息盒子',
            // component: messageBox,
            component: resolve => require(['@/views/messageBox'], resolve),
            meta: {
                requireAuth: false
            }
        },
        {
            path: '/registers',
            name: '企业注册',
            // component: registers,
            component: resolve => require(['@/views/register/registers.vue'], resolve),
            meta: {
                requireAuth: false,
                keepAlive: true
            }
        },
        {
            path: '/information',
            name: '注册提交',
            //component: information,
            component: resolve => require(['@/views/register/information'], resolve),
            meta: {
                requireAuth: false
            }
        },
        {
            path: '/register',
            name: '注册审核',
            // component: register,
            component: resolve => require(['@/views/register/index'], resolve),
            meta: {
                requireAuth: false
            }
        },
        {
            path: '/success',
            name: '注册成功',
            //component: success,
            component: resolve => require(['@/views/register/success'], resolve),
            meta: {
                requireAuth: false
            }
        },
        {
            path: '/electricianEmit',
            name: '注册',
            //component: electricianEmit,
            component: resolve => require(['@/views/register/electricianEmit'], resolve),
            meta: {
                requireAuth: false
            }
        },
        {
            path: '/retrievePassword',
            name: '找回密码',
           // component: retrievePassword,
            component: resolve => require(['@/views/retrievePassword'], resolve),
            hidden: true,
            meta: {
                requireAuth: false
            }
        },
        {
            path: '/appdown',
            name: 'APP下载',
            //component: appdown,
            component: resolve => require(['@/views/appdown'], resolve),
            hidden: true,
            meta: {
                requireAuth: false
            }
        },
        {
            path: '/initialPasswordSet',
            name: '修改登录初始密码',
            //component: initialPasswordSet,
            component: resolve => require(['@/views/initialPasswordSet'], resolve),
            hidden: true,
            meta: {
                requireAuth: false
            }
        },
        {
            path: '/userAgreement',
            name: '用户协议',
            //component: userAgreement,
            component: resolve => require(['@/views/userAgreement'], resolve),
            hidden: true,
            meta: {
                requireAuth: false
            }
        },
        {
            path: '/privacyAgreement',
            name: '隐私协议',
            //component: privacyAgreement,
            component: resolve => require(['@/views/privacyAgreement'], resolve),
            hidden: true,
            meta: {
                requireAuth: false
            }
        },
        {
            path: '/merchantAgreement',
            name: '商家入驻协议条款',
            //component: merchantAgreement,
            component: resolve => require(['@/views/merchantAgreement'], resolve),
            hidden: true,
            meta: {
                requireAuth: false
            }
        },
        {
            path: '/welConvention',
            name: '商家入驻公约',
            component: resolve => require(['@/views/welConvention'], resolve),
            hidden: true,
            meta: {
                requireAuth: true
            }
        },
        {
            path: '/wxERweima',
            name: '微信支付二维码',
            //component: wxERweima,
            component: resolve => require(['@/views/shoppingcart/wxERweima'], resolve),
            hidden: true,
            meta: {
                requireAuth: true
            }
        },
        {
            path: '/wxBound',
            name: '微信绑定',
            //component: wxBound,
            component: resolve => require(['@/views/wxBound'], resolve),
            hidden: true,
            meta: {
                requireAuth: false
            }
        },
        {
            path: '/accountUpgrade',
            name: '账号升级',
            component: resolve => require(['@/views/accountUpgrade/index.vue'], resolve),
            hidden: true,
            meta: {
                requireAuth: true
            }
        },
        /** 站点导航 */
        {
            path: '/siteNavigation',
            name: '站点导航首页',
            // component: siteNavigation,
            component: resolve => require(['@/views/siteNavigation/siteNavigation'], resolve),
            iconCls: 'el-icon-tickets',
            redirect: '/userCenter',
            hidden: true,
            meta: {
                requireAuth: true
            },
            children: [{
                    path: '/userCenter',
                    name: '用户中心',
                    // component: userCenter,
                    component: resolve => require(['@/views/siteNavigation/userCenter'], resolve),
                    meta: {
                        requireAuth: true
                    }
                },
                {
                    path: '/paymentCenter',
                    name: '支付中心',
                    // component: paymentCenter,
                    component: resolve => require(['@/views/siteNavigation/paymentCenter'], resolve),
                    meta: {
                        requireAuth: true
                    }
                },


            ]
        },



        // 以下 批发市场 供应商 首页
        {
            path: '/supplier',
            name: '供应商首页',
            // component: supplier,
            component: resolve => require(['@/views_supplier/index'], resolve),
            iconCls: 'el-icon-tickets',
            redirect: '/supplierIndex',
            hidden: true,
            meta: {
                requireAuth: false
            },
            children: [{
                    path: '/supplierIndex',
                    name: '供应商嵌套在首页',
                    // component: main_supplier,
                    component: resolve => require(['@/views_supplier/dashboard/main'], resolve),
                    meta: {
                        requireAuth: false
                    }
                }, {
                    path: '/store_supplier',
                    name: '店铺馆',
                    // component: store_supplier,
                    component: resolve => require(['@/views_supplier/store/store'], resolve),
                    meta: {
                        requireAuth: false
                    }
                },
                {
                    path: '/shopStore_supplier',
                    name: '店铺详情_supplier',
                    // component: shopStore_supplier,
                    component: resolve => require(['@/views_supplier/store/storeHome'], resolve),
                    meta: {
                        requireAuth: false
                    }
                },
                // {
                //     path: '/goodsList_supplier',
                //     name: '商品列表',
                //     // component: goodsList_supplie,
                //     component: resolve => require(['@/views_supplier/goodsList/index'], resolve),
                //     hidden: true,
                //     meta: {
                //         requireAuth: false
                //     }
                // },
                // {
                //     path: '/contactUs',
                //     name: '联系我们',
                //     component: contactUs,
                //     hidden: true,
                //     meta: {
                //         requireAuth: false
                //     }
                // },
                {
                    path: '/goodsDetail_supplie',
                    name: '商品详情_supplie',
                    // component: goodsDetail_supplie,
                    component: resolve => require(['@/views_supplier/goodsList/goodsDetail'], resolve),
                    hidden: true,
                    meta: {
                        requireAuth: false
                    }
                },
            ]
        },

    ]
})



// WEBPACK FOOTER //
// ./src/router/index.js